import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { useTheme, Grid, Typography, Button } from '@material-ui/core'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import VerifyPhoneNumber from '../../../components/VerifyPhoneNumber'
import Stepper from '../../../components/StepperV2'
import Paper from '@material-ui/core/Paper'
import { withRouter } from 'react-router'
import { getCreatorInfo, signIn } from '../../../redux/actions'
import { connect } from 'react-redux'
import { reduxForm, change } from 'redux-form'
import { creatorInfoSelector, verifyPhoneMaskSelector } from '../../../redux/selectors'
import { injectIntl } from 'react-intl'
import queryString from 'query-string'
import RegistrationPagesWrapper from '../../../components/RegistrationPagesWrapper'
import { getUser } from '../../../utilties/userUtilities'

const useStyles = makeStyles((theme) => ({
	gridStyle: {
	  maxWidth: '479px',
	  width: '90%',
	  margin: '0 auto',
	  boxSizing: 'border-box',
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	},
  }));

const Login = ({
	handleSubmit,
	intl,
	location,
	login,
	changeEmail,
	history,
	getCreatorInfo,
	creatorInfo
}) => {
	const classes = useStyles()
    const theme = useTheme()
	const [returnPath, setReturnPath] = useState(null)
    const [rememberMe, setRememberMe] = React.useState(true);
	const user = getUser()

    const [authRequest, setAuthRequest] = useState(() => () => { })

	const onSubmitForm = (values) => {
        setAuthRequest(() => () => login(values.email, values.password, rememberMe, returnPath, intl.locale))
		login(values.email, values.password, rememberMe, returnPath, intl.locale)
	}

    const handleChange = event => {
        setRememberMe(event.target.checked);
    };

	useEffect(() => {
		const values = queryString.parse(location.search)

		if (values.returnUrl) {
			setReturnPath(values.returnUrl)
		}

		if (values.email) {
			changeEmail(values.email)
		}
	}, [])

	useEffect(
		() => {
			if (!!user && !creatorInfo) {
				getCreatorInfo()
			}
		},
		[user]
	)

	return (
		<LoginPagesWrapper>
			<RegistrationPagesWrapper
				showCreatorInfoPanel={true}
			>
				<div
					style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
					<Paper className={classes.gridStyle} elevation={2}>
						<VerifyPhoneNumber
							mode="attach"
							onSuccessRedirectUrl="/auth/terms"
						/>
						<Grid item container direction="column" 
							className="stepper-register-wrapper"
							style={{ marginTop: '10px', marginBottom: '4rem' }}>
							<Grid item xs={12} style={{marginTop: '20px', marginBottom: '20px'}}>
								<Stepper
									stepsCount={4}
									selectedStep={3}
									stepNumber={3}
								/>
							</Grid>
						</Grid>
					</Paper>
				</div>
			</RegistrationPagesWrapper>
		</LoginPagesWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
	failed: state.auth.failedLogin,
    verifyPhoneMask: verifyPhoneMaskSelector(state),
	creatorInfo: creatorInfoSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	changeEmail: (email) => dispatch(change('login', 'email', email)),
	login: (email, password, rememberMe, returnUrl, language) => dispatch(signIn(email, password, rememberMe, returnUrl, language)),
	getCreatorInfo: () => dispatch(getCreatorInfo())
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: 'login'
	}),
	withRouter
)

export default enhance(Login)
